import { requestCallCenter, unwrapEnvelopeValue } from "./CallCenterApi";

const CAMPAIGNS_BASE = "campaigns";

export const createCampaign = async (payload) => {
  const envelope = await requestCallCenter({
    method: "post",
    url: CAMPAIGNS_BASE,
    data: payload,
  });
  return unwrapEnvelopeValue(envelope, "Failed to create campaign");
};

export const updateCampaign = async (campaignId, payload) => {
  const envelope = await requestCallCenter({
    method: "put",
    url: `${CAMPAIGNS_BASE}/${campaignId}`,
    data: payload,
  });
  return unwrapEnvelopeValue(envelope, "Failed to update campaign");
};

export const getCampaignById = async (campaignId) => {
  const envelope = await requestCallCenter({
    method: "get",
    url: `${CAMPAIGNS_BASE}/${campaignId}`,
  });
  return unwrapEnvelopeValue(envelope, "Failed to fetch campaign");
};

export const listCampaigns = async () => {
  const envelope = await requestCallCenter({
    method: "get",
    url: CAMPAIGNS_BASE,
  });
  return unwrapEnvelopeValue(envelope, "Failed to list campaigns");
};

export const deleteCampaign = async (campaignId) => {
  const envelope = await requestCallCenter({
    method: "delete",
    url: `${CAMPAIGNS_BASE}/${campaignId}`,
  });
  return unwrapEnvelopeValue(envelope, "Failed to delete campaign");
};

export const getCampaignDashboard = async (params) => {
  const envelope = await requestCallCenter({
    method: "get",
    url: `${CAMPAIGNS_BASE}/dashboard`,
    params,
  });
  return unwrapEnvelopeValue(envelope, "Failed to load campaign dashboard");
};

export const listCampaignTasks = async (campaignId) => {
  const envelope = await requestCallCenter({
    method: "get",
    url: `${CAMPAIGNS_BASE}/${campaignId}/tasks`,
  });
  return unwrapEnvelopeValue(envelope, "Failed to load campaign tasks");
};
